import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import ShippingAutoReplenishDeliveryInfoMessage from 'components/RwdCheckout/Shared/ShippingAutoReplenishDeliveryInfoMessage/ShippingAutoReplenishDeliveryInfoMessage';
import ShippingAutoReplenishDeliveryInfoMessageEN from 'components/RwdCheckout/Shared/ShippingAutoReplenishDeliveryInfoMessage/locales/ShippingAutoReplenishDeliveryInfoMessage_en_US.js';
import ShippingAutoReplenishDeliveryInfoMessageFR from 'components/RwdCheckout/Shared/ShippingAutoReplenishDeliveryInfoMessage/locales/ShippingAutoReplenishDeliveryInfoMessage_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(ShippingAutoReplenishDeliveryInfoMessageEN, ShippingAutoReplenishDeliveryInfoMessageFR);

const textResources = createStructuredSelector({
    shippingAutoReplenishMessage: getTextFromResource(getText, 'shippingAutoReplenishMessage')
});

const connectedShippingAutoReplenishDeliveryInfoMessage = connect(
    createSelector(textResources, ({ shippingAutoReplenishMessage }) => {
        return { shippingAutoReplenishMessage };
    })
);

const withShippingAutoReplenishDeliveryInfoMessageProps = wrapHOC(connectedShippingAutoReplenishDeliveryInfoMessage);

export default withShippingAutoReplenishDeliveryInfoMessageProps(ShippingAutoReplenishDeliveryInfoMessage);
